import { render, staticRenderFns } from "./XS.vue?vue&type=template&id=ee2b53f6&scoped=true&"
import script from "./XS.vue?vue&type=script&lang=js&"
export * from "./XS.vue?vue&type=script&lang=js&"
import style0 from "./XS.vue?vue&type=style&index=0&id=ee2b53f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2b53f6",
  null
  
)

export default component.exports